export default "__VITE_ASSET__Dpdap5gA__"